import React from "react";
import styled, { css, keyframes } from "styled-components";

const Rotate = keyframes` 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } `;
const Animation = css`
  animation: ${Rotate} 2s linear infinite;
`;


const Loader = styled.div`
  overflow: hidden;
  border: 8px solid #f3f3f3;
  border-radius: 50%;
  position: relative;
  ${({$center})=> $center && "margin: 0 auto;"}
  ${({ $size, $color }) => `
    width: ${$size};
    height: ${$size};
    border-top: 8px solid ${$color};
  `}
  ${Animation}
`;

Loader.defaultProps = {
  $size: "20px",
  $color: "#0052ec",
};

export default Loader;
